module.exports = __webpack_public_path__ + "focus.svg-foreign-object-hack-8956.js";


//////////////////
// WEBPACK FOOTER
// ./node_modules/ally.js/esm/element/focus.svg-foreign-object-hack.js
// module id = 440
// module chunks = 4